<template>
    <div class="modal is-active"  >
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title  is-size-3" v-if="dataToChild.kind === 1 "> Add New Delete Order Reason  </p>
                <p class="modal-card-title  is-size-3 " v-if="dataToChild.kind === 2 "> Edit Delete Order Reason  </p>
                <button class="delete" aria-label="close"   @click="closeBtn" ></button>
            </header>

            <section class="modal-card-body">
                <!--                  content-->

                <b-field label="DESCP.">
                    <b-input type="text" v-model="dataToChild.dataEdit.name">  </b-input>
                </b-field>
                <b-field label="Status">
                    <b-switch  type="is-success" v-model=" dataToChild.dataEdit.enable "></b-switch>
                </b-field>

            </section>
            <footer class="modal-card-foot">
                <!--                <button class="button is-danger"   @click="closeBtn" >Cancel</button>-->
                <b-button type="is-danger"
                          icon-right="close"
                          @click="closeBtn" >Cancel</b-button>
                &nbsp;&nbsp;&nbsp;
                <b-button type="is-success"
                          icon-right="cloud-upload"
                          @click="insertOrUpdateData"
                >Save</b-button>

            </footer>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import { getBaseURLforBackEnd  , getConfigAxios  }  from '@/utils.js'
    import { mapState } from "vuex";

    export default {
        name: "AddNewAndEditDeleteOrderReason",
        props:{
            dataToChild : {kind : null,dataEdit: null}  // kind 1 addNew , 2 edit
        },
        computed:{
             ...mapState({
                access_token: state => state.master_data.access_token,
            })
        },
        methods:{
            insertOrUpdateData(){
                /* eslint-disable */


                const vm = this

                var urlConst = ""
                var datTo = null
                if(this.dataToChild.kind === 1){
                    urlConst = `${getBaseURLforBackEnd()}/api/newdeleteorderreason`
                    datTo = {
                        "name" : this.dataToChild.dataEdit.name,
                    }


                }else if(this.dataToChild.kind === 2){
                    urlConst = `${getBaseURLforBackEnd()}/api/updatedeleteorderreason`
                    datTo = {
                        "id" : this.dataToChild.dataEdit.id,
                        "name" : this.dataToChild.dataEdit.name,
                        "enable" : this.dataToChild.dataEdit.enable
                    }
                }


                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}` 
                axios.post(urlConst,datTo,getConfigAxios())
                    .then((res)=>{
                        vm.$buefy.toast.open({
                            message: `${res.data.msg}`,
                            type: 'is-success'
                        })

                        this.$emit('closeWithChange')

                    })
                    .catch(err=>{
                        vm.isFullScreenLoading = false
                        vm.$buefy.dialog.alert({
                            title: 'Error',
                            message: `Error  from ${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    })

            },
            closeBtn(){
                this.$emit('close')
            }
        }
    }
</script>

<style scoped>

</style>